export default (that) => [
  {
    text: that.$l('btn_tips_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_edit') || '编辑方案',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    show: ({ evgPackingSchemeStatus }) => evgPackingSchemeStatus === 'N',
  },
  {
    text: that.$l('btn_tips_del') || '删除方案',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    show: ({ evgPackingSchemeStatus }) => evgPackingSchemeStatus === 'N',
  },
  {
    text: that.$l('btn_tips_check') || '方案启用',
    icon: 'el-icon-check',
    menuType: 'solutionEnabled',
    divided: true,
    allow: 'C',
    data: {},
    show: ({ evgPackingSchemeStatus }) =>
      evgPackingSchemeStatus === 'N' || evgPackingSchemeStatus === 'S',
  },
  {
    text: that.$l('btn_tips_pause') || '方案停用',
    icon: 'el-icon-video-pause',
    menuType: 'deactivate',
    divided: true,
    allow: 'S',
    data: {},
    show: ({ evgPackingSchemeStatus }) => evgPackingSchemeStatus === 'Y',
  },
  {
    text: that.$l('btn_tips_copy') || '复制方案',
    icon: 'el-icon-copy-document',
    menuType: 'copy',
    divided: true,
    allow: 'P',
    show: ({ evgPackingSchemeStatus }) => evgPackingSchemeStatus !== 'D',
  },
]
